import { enableProdMode, inject, provideZoneChangeDetection, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { routes } from './app/app-routing.module';
import { ErrorHandlingInterceptor } from './app/interceptors/error-handling.interceptor';
import { AwsAuthService } from './app/services/aws-auth.service';
import { TranslationService } from './app/services/translation.service';
import { NotificationService } from './app/services/notification.service';
import { AppRedirectService } from './app/services/app-redirect.service';
import { CrowdinOtaService } from './app/services/crowdin-ota/crowdin-ota.service';
import { WorkbenchModule } from '@workbench/angular';
import { firstValueFrom, tap } from 'rxjs';
import { CountrySelectorComponent } from './app/modules/shared/country-selector/country-selector.component';
import { CountryCodeInterceptor } from './app/interceptors/country-code.interceptor';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlingInterceptor, multi: true },
         { provide: HTTP_INTERCEPTORS, useClass: CountryCodeInterceptor, multi: true },
        importProvidersFrom(TranslateModule.forRoot(), WorkbenchModule),
        AwsAuthService,
        AppRedirectService,
        NotificationService,
        CrowdinOtaService,
        CountrySelectorComponent,
        provideAppInitializer(() => {
            const translationService = inject(TranslationService);
            return firstValueFrom(translationService.getAllFeatureFlags().pipe(
                tap((featureFlags: any) => {
                    translationService.featureFlags = featureFlags;
                })
            ));
        })
    ]
})
.catch((err) => console.error(err));


